import React from 'react'

import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { withStyles } from '@material-ui/core/styles'
import toLower from 'lodash/toLower'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as Model from 'api/model'
import LayerPanelsExpansion from 'drawer/tabs/layers/panels/LayerPanelsExpansion'
import { closeTable, openTable, setTableLayer, setTableStatus } from 'drawer/tabs/layers/table/actions'
import { TABLE_STATUS_CLOSING, TABLE_STATUS_OPENING } from 'drawer/tabs/layers/table/LayerTable'
import Upgrade from 'drawer/tabs/Upgrade'
import Loading from 'utils/Loading'

import IconTable from './IconTable'
import { ICON_COLOR_DISABLED, ICON_COLOR_ENABLED, PANEL_TITLE_TABLE, SHOW_TABLE_MIN_HEIGHT, SHOW_TABLE_MIN_WIDTH } from './LayerPanels'
import { SET_LAYER_LOAD_IN_PROGRESS } from '../actions'

const styles = theme => ({
  root: {
    padding: 10
  },
  checkbox: {},
  content: {
    display: 'flex'
  },
  formControlLabel: {
    '& span.MuiFormControlLabel-label': {
      display: 'block'
    },
    display: 'flex',
    flex: 1,
    '&:hover': {
      background: '#eaeaea'
    }
  },
  label: {
    alignItems: 'center',
    columnGap: 10,
    display: 'flex',
    fontSize: 15
  },
  notLicensed: {}
})

class LayerPanelTable_ extends React.Component {
  constructor (props) {
    super(props)
    const { tableOpen, tableTitleid, titleid } = this.props

    this.pure = {}
    this.pure.upgradeText = 'Upgrade Pozi to enable table data view with advanced search, sort and filter capability.'
    this.pure.upgradeURL = Model.get('config.layout.drawer.tabs.tools.selectgroup.upgrade.url', '')
    this.pure.upgradeURLLabel = Model.get('config.layout.drawer.tabs.tools.selectgroup.upgrade.urlLabel', 'Learn More')
    this.pure.upgradeMarkup = <Upgrade text={this.pure.upgradeText} url={this.pure.upgradeURL} urlLabel={this.pure.upgradeURLLabel} />

    // Determine whether the checkbox should be checked upon the opening of the menu
    const checked = tableOpen && tableTitleid === titleid

    this.state = {
      checked
    }
  }

  // If the dimensions ofthe device are too small, we don't support displaying the table
  getTableSupported = () => {
    let tableSupported = true

    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    if (width < SHOW_TABLE_MIN_WIDTH || height < SHOW_TABLE_MIN_HEIGHT) {
      tableSupported = false
    }

    return tableSupported
  }

  onExpansionPanelChange = (bPanelOpening) => {
    // Close table when panel collapses
    if (!bPanelOpening) {
      this.closeTable()
    }
  }

  closeTable = () => {
    const { dispatchCloseTable, dispatchSetTableStatus, onSelect } = this.props

    dispatchSetTableStatus(TABLE_STATUS_CLOSING)
    dispatchCloseTable()

    // Apply callback function
    onSelect(false)
  }

  openTable = () => {
    const { dispatchOpenTable, dispatchCloseTable, dispatchSetTableStatus, layerLoadStatus, onSelect, titleid } = this.props

    // Delay opening table due to potentially blocking the UI for some time
    // TODO: find a way around this. Also, maybe only delay if the table is big
    //       (we can determine this by the number or rows in the data)

    dispatchCloseTable()

    dispatchSetTableStatus(TABLE_STATUS_OPENING)

    window.setTimeout(() => {
      const layerDataPath = `app.config.layerbytitleid[${titleid}].data`

      // Handle situation where layer is still loading. We will then hold off
      // opening the table until the data is loaded.
      if (layerLoadStatus === SET_LAYER_LOAD_IN_PROGRESS) {
        console.debug('openTable - layer load in progress', titleid)

        // Listen to changes in the model for updates to the layer data
        const modelObserverId = Model.on(layerDataPath, (layerData) => {
          console.debug('openTable - layer loaded', titleid)

          // Make sure that this listener is removed
          Model.un(layerDataPath, modelObserverId)

          dispatchOpenTable(titleid, layerData)

          // Apply callback function to close the menu
          onSelect(true)
        })
      } else {
        const layerData = Model.get(layerDataPath, null)
        dispatchOpenTable(titleid, layerData)

        // Apply callback function to close the menu
        onSelect(true)
      }
    }, 100)
  }

  toggleTable = (evt) => {
    const { titleid } = this.props

    const tableSupported = this.getTableSupported()
    if (!tableSupported) {
      console.log('toggleTable - table not supported due to small screen size', titleid)
      return
    }

    const checked = evt.target.checked

    // console.debug('toggleTable', titleid, checked, { ...evt.target })

    if (checked) {
      console.debug('toggleTable - open table')
      this.openTable()
    } else {
      console.debug('toggleTable - close table')
      this.closeTable()
    }

    this.setState({
      checked
    })
  }

  render () {
    const { classes, titleid, layerLoadStatus, layerType, tableOpen, tableStatus, tableTitleid } = this.props
    const { checked } = this.state

    if (toLower(layerType) !== 'geojson') {
      return null
    }

    let icon = ''
    let markup = ''

    const licensed = Model.get('config.layout.drawer.tabs.layers.table.enabled', false)
    if (!licensed) {
      icon = <IconTable htmlColor={ICON_COLOR_DISABLED} />
      markup = (
        <div className={classes.root}>
          {this.pure.upgradeMarkup}
        </div>
      )
      return <LayerPanelsExpansion titleid={titleid} panelTitle={PANEL_TITLE_TABLE} headerIcon={icon} markup={markup} licensed={licensed} />
    }

    icon = <IconTable htmlColor={ICON_COLOR_ENABLED} />

    let content = ''
    const tableSupported = this.getTableSupported()

    // console.debug('render - table', checked, tableStatus, tableOpen, tableTitleid, layerLoadStatus)

    if (tableSupported) {
      content = (
        <div className={classes.content}>
          <FormControlLabel className={classes.formControlLabel}
            control={
              <Checkbox className={classes.checkbox} size="small" color="default" onChange={this.toggleTable} value={titleid} checked={checked} />
            }
            label={
              (<div className={classes.label}>
                View table
                {tableStatus === TABLE_STATUS_OPENING && <Loading text="" /> }
              </div>)}
          />
        </div>
      )
    } else {
      content = 'Table not supported for current screen size.'
    }
    markup = (
      <div className={classes.root}>
        {content}
      </div>
    )
    return <LayerPanelsExpansion titleid={titleid} panelTitle={PANEL_TITLE_TABLE} headerIcon={icon} markup={markup} licensed={licensed} cb={this.onExpansionPanelChange} />
  }
}

LayerPanelTable_.propTypes = {
  classes: PropTypes.object.isRequired,
  layerLoadStatus: PropTypes.string.isRequired,
  layerType: PropTypes.string.isRequired,
  titleid: PropTypes.string.isRequired,
  tableOpen: PropTypes.bool,
  tableStatus: PropTypes.string.isRequired,
  tableTitleid: PropTypes.string,
  dispatchCloseTable: PropTypes.func.isRequired,
  dispatchOpenTable: PropTypes.func.isRequired,
  dispatchSetTableStatus: PropTypes.func.isRequired,
  onSelect: PropTypes.func
}

function mapStateToProps (state, ownProps) {
  const layerState = state.layers[ownProps.titleid]
  const layerLoadStatus = layerState.loadstatus || ''
  const layerType = layerState.type || ''
  const tableStatus = state.table.status
  const tableOpen = state.table.open
  const tableTitleid = state.table.titleid

  return {
    layerLoadStatus,
    layerType,
    tableOpen,
    tableStatus,
    tableTitleid
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatchOpenTable: (titleid, data) => {
      dispatch(openTable(titleid, data))
    },
    dispatchCloseTable: () => {
      dispatch(closeTable())
    },
    dispatchSetTableLayer: (titleid) => {
      dispatch(setTableLayer(titleid))
    },
    dispatchSetTableStatus: (status) => {
      dispatch(setTableStatus(status))
    }
  }
}

const LayerPanelTable = (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(LayerPanelTable_)
  )
)

export default LayerPanelTable
